//utils.ts

export const transformToCamelCase = (response: any, keysMap: any): any => {
  if (response && Array.isArray(response)) {
    return (
      (response.length > 0 &&
        response.map((item) => transformToCamelCase(item, keysMap))) ||
      []
    );
  }

  if (response && typeof response === 'object') {
    return Object.keys(response).reduce((obj: any, key) => {
      const propKey = transformToCamelCase(key, keysMap);
      if (typeof response[key] === 'object') {
        const propVal = transformToCamelCase(response[key], keysMap);
        obj[propKey] = propVal;
      } else {
        obj[propKey] = response[key];
      }
      return obj;
    }, {});
  }

  if (typeof response === 'string') {
    return keysMap[response] || response;
  }

  return response;
};
